import { render } from "./ApiKeysTab.vue?vue&type=template&id=2c0a6b95"
import script from "./ApiKeysTab.vue?vue&type=script&lang=js"
export * from "./ApiKeysTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__